import {
    FACEBOOK_SHARE_URL,
    TWITTER_SHARE_URL,
    TUMBLR_SHARE_URL
} from '../../constants';

const ShareOverlay = function (data) {
	const embed = (data.embedCode) ? `
		<div class="embed-code">
			<div class="embed-code-text">Embed:</div>

			<div class="embed-code-input-wrapper">
				<input id="embed-code-input" type="text" value="${ data.embedCode }" onclick="this.setSelectionRange(0, this.value.length);"/>
			</div>

			<div class="copy-button" data-copy-target="#embed-code-input">Copy</div>
		</div>
	` : '';

	const timecode = (data.timecode) ? `
		<div class="timecode-selection">
			<div class="checkbox-wrapper">
				<input type="checkbox" id="timecode-selection" />
				<label for="timecode-selection">Start at <span class="timecode">${ data.timecode}</span></label>
				<input type="text" id="timecode-input" value="${ data.timecode }" />
			</div>
		</div>
	` : '';

	return `
	<div class="share-overlay-content">
		<div class="share-icons">
			<div class="share-text">Share</div>

			<div class="facebook-icon">
				<a href="${ FACEBOOK_SHARE_URL + data.directLink }" data-user-interaction="click:share:facebook" target="_blank">
					<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 27.6 27.6" enable-background="new 0 0 27.6 27.6" xml:space="preserve">
					<path fill="#FFFFFF" d="M13.8,27.6c7.6,0,13.8-6.2,13.8-13.8S21.4,0,13.8,0C6.2,0,0,6.2,0,13.8S6.2,27.6,13.8,27.6z M9.6,11.7h2.5
						V9.4c0,0-0.1-1.5,1-2.6c1.1-1.1,2.6-1,4.8-0.8v2.5h-1.6c0,0-0.7,0-1,0.3c-0.3,0.4-0.3,0.9-0.3,1v1.8h2.8l-0.4,2.8h-2.4v7.3h-2.9
						v-7.3H9.6V11.7z"/>
					</svg>
				</a>

			</div>

			<div class="twitter-icon">
				<a href="${ TWITTER_SHARE_URL + data.directLink }" data-user-interaction="click:share:twitter" target="_blank">
					<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 27.6 27.6" enable-background="new 0 0 27.6 27.6" xml:space="preserve">
					<path fill="#FFFFFF" d="M13.8,27.6c7.6,0,13.8-6.2,13.8-13.8S21.4,0,13.8,0S0,6.2,0,13.8S6.2,27.6,13.8,27.6z M10.5,17.5
						c0,0-2.4,0-3.1-2.3c0,0,1.2,0.1,1.4-0.1c0,0-2.6-0.6-2.6-3.3c0,0,0.8,0.4,1.5,0.4c0,0-2.5-1.8-1-4.5c0,0,2.5,3.3,6.8,3.5
						c0,0-0.6-2,1.2-3.5c1.8-1.5,4-0.2,4.5,0.3c0,0,1.3-0.2,2.2-0.8c0,0-0.3,1.1-1.4,1.8c0,0,1.3-0.2,1.8-0.5c0,0-0.6,1-1.7,1.7
						c0,0,0.4,4.1-3.1,7.5c-3.6,3.4-9.4,2.7-11.5,0.9C5.7,18.9,8.5,19.2,10.5,17.5z"/>
					</svg>
				</a>

			</div>

			<div class="tumblr-icon">
				<a href="${ TUMBLR_SHARE_URL + data.directLink }" data-user-interaction="click:share:tumblr" target="_blank">
					<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 27.6 27.6" enable-background="new 0 0 27.6 27.6" xml:space="preserve">
					<path fill="#FFFFFF" d="M13.8,0C6.2,0,0,6.2,0,13.8s6.2,13.8,13.8,13.8c7.6,0,13.8-6.2,13.8-13.8S21.4,0,13.8,0z M17.9,20.7
						c0,0-1.6,0.4-2.6,0.4c-1,0-3.7-0.1-4.2-2.9v-6H9.6V9.7h0.4c0,0,1.3-0.3,1.8-1.3c0.6-1,0.5-1.8,0.5-1.8h2.1v3.2h3.3v2.5h-3.2v4.1
						c0,0,0,0.7,0.1,0.9c0.1,0.3,0.6,0.9,1.4,0.9c0.8,0,2-0.5,2-0.5V20.7z"/>
					</svg>
				</a>
			</div>
		</div>

		<div class="direct-link">
			<div class="direct-link-text">Direct Link:</div>

			<div class="direct-link-input-wrapper">
				<input id="direct-link-input" type="text" value="${ data.directLink }" onclick="this.setSelectionRange(0, this.value.length);"/>
			</div>

			<div class="copy-button" data-copy-target="#direct-link-input">Copy</div>
		</div>

		${ timecode }

		${ embed }
	</div>`;
};

export default ShareOverlay;



// WEBPACK FOOTER //
// ./src/ui/share/ShareOverlay.js